import { flushSync } from 'react-dom';
import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer, useState, useCallback } from 'react';
// import { useNavigate } from 'react-router';
import { initializeApp } from 'firebase/app';
import {
	getAuth,
	getIdToken,
	signOut,
	onAuthStateChanged,
	signInWithEmailAndPassword,
	createUserWithEmailAndPassword,
    sendPasswordResetEmail,
	sendEmailVerification,
	applyActionCode,
	RecaptchaVerifier,
	PhoneAuthProvider,
	PhoneMultiFactorGenerator,
	multiFactor,
	AuthErrorCodes,
	getMultiFactorResolver,
	signInWithCustomToken,
	updateCurrentUser,

} from 'firebase/auth';
import {
    getFirestore, collection, query, where, getDocs
} from 'firebase/firestore';
import axios from '../utils/axios';
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';
//
import { FIREBASE_API } from '../config';
// ----------------------------------------------------------------------

const firebaseApp = initializeApp(FIREBASE_API);

export const AUTH = getAuth(firebaseApp);
const DB = getFirestore(firebaseApp);
const initialState = {
	isAuthenticated: false,
	isInitialized: false,
	user: null,
    role: null,
    state: "loggedOut"
};

const reducer = (state, action) => {
	if (action.type === 'INITIAL' || action.type === "MFAEnroll" || action.type === "MFA") {
		const { isAuthenticated, user, role } = action.payload;
		return {
			...state,
			isAuthenticated,
			isInitialized: true,
			user,
            state: action.payload.state,
            role,
		};
	} 
	return state;
};

const AuthContext = createContext({
	...initialState,
	method: 'firebase',
	loginWithToken: () => Promise.resolve(),
	loginWithEmailPassword: () => Promise.resolve(),
	register: () => Promise.resolve(),
	logout: () => Promise.resolve(),
	resendEmail: () => Promise.resolve(),
	verifyPhoneNumber: ()=> Promise.resolve(),
	getPhoneAuthProvider: ()=>Promise.resolve(),
	getUserId: ()=>Promise.resolve(),
	setUserAuth: ()=>Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
	children: PropTypes.node,
};

function AuthProvider({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);
	// const navigate = useNavigate();
    const toast=1;

	const [profile, setProfile] = useState(null);
	const [currRole, setRole] = useState(null);

    const initialize = useCallback(() => {
        try{
            onAuthStateChanged(AUTH, async (user) => {
                if (user){ // disabling emailVerification check && user.emailVerified) {
                    // const mfUser = multiFactor(user);
                    // const isMFAEnabled = mfUser.enrolledFactors.length !==0
                    // console.log(isMFAEnabled);
                    // if(isMFAEnabled === false){
                    //     console.log("mfa is not enabled dispatching");
                    //     dispatch({
                    //         type: "MFAEnroll",
                    //         payload: {
                    //             isAuthenticated: false,
                    //             user: {
                    //                 ...user,
                    //                 role: ""
                    //             },
                    //             state: "MFAEnroll"
                    //         }
                    //     })
                    // } else {
                        const token = await getUserIdToken();
                        axios.post('/userRole', {token})
                        .then((resp)=>{
                            if(resp.data !== 'error'){
                                console.log(resp)
                                setRole(resp.data.data.role);
                                const userRole = resp.data.data.role;

                                dispatch({
                                    type: 'INITIAL',
                                    payload: { 
                                        isAuthenticated: true, 
                                        user: {
                                            ...user,
                                            role: userRole,
                                        },
                                        state: "loggedIn" 
                                    },
                                });        
                            } else {
                                logout();
                            }
                        })
                    // }

                } else {
                    dispatch({
                        type: 'INITIAL',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                        state: "loggedOut"
                    });
                }
            });
        } catch (error) {
          console.error(error);
        }
      }, []);
      
    useEffect(() => {
        initialize();
    }, []);


	const handleUserLogin = (userCredentials) => {
			// A helper function that I call after any of the firebase login functions
			// authenticates the user.
			const user = userCredentials.user;
			const uid = user.uid;
			
			// If the users email is not verified sign them out of the client side firebase api
			// and return a Email Not Verified error that the user sees.
			// if(!user.emailVerified){
			// 	logout();
			// 	// setUserAuth(false, null);
			// 	throw new Error('Email Not Verified');
			// }
			
	}

	const setUserAuth = (state, user)=>{
			dispatch({
				type: 'INITIALISE',
				payload: { isAuthenticated: state, user },
			}); 
	} 

	const handleUserLoginErrors = (error)=>{
		// Handles all the error handling for login
		let retError = Error();
		if(error.code === AuthErrorCodes.INVALID_PASSWORD){
			retError = Error('The password or email address entered is incorrect. Please try again.');
		} else if(error.code === AuthErrorCodes.MFA_REQUIRED){
				try{
					retError = Error('No error');
					const jsonError = JSON.stringify(error);
					sessionStorage.setItem('mfaRequiredError', jsonError);
					const resolver = getMultiFactorResolver(AUTH, error);
					// window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {'size':'invisible'}, AUTH);
					const phoneInfoOptions = {
						multiFactorHint: resolver.hints[0],
						session: resolver.session
					};
					const provider = new PhoneAuthProvider(AUTH);
					// const serverAddr = `/createVerifyId`;
					provider.verifyPhoneNumber(phoneInfoOptions, window.recaptchaVerifier)
					.then((verificationId) =>{
							sessionStorage.setItem('verificationId', verificationId);
							// sessionStorage.setItem('loggingIn','yes');
							// window.location.href = PATH_AUTH.verify;
                            retError = Error("MFA")
                            dispatch({
                                type: 'MFA',
                                payload: {
                                    isAuthenticated: false,
                                    user: null,
                                    role: null,
                                    state: "MFA"
                                }
                            })
					})
				} catch(errorHandlingError) {
						if(errorHandlingError.code === AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER)
							retError = Error('Too many login attempts. Try Again later.');
				}
		} else if(error.code === AuthErrorCodes.USER_DELETED){
			retError = Error('The password or email address entered is incorrect. Please try again.')
		} else if(error.code === AuthErrorCodes.USER_DISABLED){
			retError = Error('This account has been disabled due to unusual activity. To enable this account again, contact support at xxx-xxx-xxxx');
		} else if(error.code === AuthErrorCodes.NETWORK_REQUEST_FAILED){
			retError = Error('Failed to contact the server. Check your internet connection and try again.')
		} else if(error.message === 'Email Not Verified') {
			retError = Error(error.message);
		} else{
			retError = Error('An error has occured please try agin after some time.')
		}
		return retError;
	}


	const loginWithEmailPassword = (email, password) => 
		new Promise((resolve, reject)=>{
			// const serverAddr = `/updateUserState`;
			try{
				signInWithEmailAndPassword(AUTH, email, password)
				.then((userCredentials)=>{
						handleUserLogin(userCredentials);
						resolve();
				})
				.catch((error)=>{
					console.log(error);
					reject(handleUserLoginErrors(error));          
				});
			} catch(error){
				reject(handleUserLoginErrors(error));          
				console.log(error);
			}
		});

	const register = (email, password, firstName, lastName, middleInitial) =>
		new Promise ((resolve,reject) =>{
			const userInfo = {
				email,
				firstName,
				lastName,
				password,
                middleInitial
			}
			// const registerAddr = `/register`
			// console.log(registerAddr);
			// console.log(userInfo);
			// axios.post(registerAddr, userInfo)
			// .then(res=>{
			// 	console.log(res);
			// 	console.log(res.data);
			// 	console.log(res.data.result === 'error');
			// 	if (res.data.result === 'success')
			// 		window.location.href = PATH_AUTH.login;
			// 	else if (res.data.result === 'error')
			// 		reject(new Error(res.data.message));
			// 	// const uid = res.data.uid;
			// })
			// .catch(error=>{
			// 	console.log(error);
			// })
		});

	const resendEmail = (email) =>{
			// axios.post(`/sendEmailVerifyLink`, {email})
			// .then(res=>{
			// 	console.log(res);
			// })
            return "";
		}

	const logout = () => 
		new Promise ((resolve, reject)=>{
			signOut(AUTH)
			try{
				updateCurrentUser(AUTH, null);
			} catch(error){
				console.log(error);
			}
			// const serverAddr = `/logout`
			// axios.post(serverAddr, {})
			// .then((res)=>{
			// 	console.log(res);
			// })
			resolve();
		})


    const resetPassword = async (email)=>{
        try{
            await sendPasswordResetEmail(AUTH, email)
            return "done"
        } catch (error){
            console.log(error)
            if(error.code === "auth/user-not-found"){
                throw Error("User Not Found.")
            }else{
                throw error
            }
        }
    }
	

	const getPhoneAuthProvider = ()=>{
		return new PhoneAuthProvider(AUTH);
	}

	const getUserId =  async()=>{
		const user = await AUTH.currentUser;
		return user.uid;
	}

	async function getUserIdToken (){

			const user =  await AUTH.currentUser;
            // console.log(user);
            try{
                const token = await user.getIdToken(true)   
                // console.log("the id token is ", token)
                return token;
            }catch(error){
				return Promise.reject(error);
			}
	}

	return (
		<AuthContext.Provider
			value={{
				...state,
				method: 'firebase',
                currentUserObj: AUTH.currentUser,
				user: {
					id: state?.user?.uid,
					email: state?.user?.email,
					photoURL: state?.user?.photoURL || profile?.photoURL,
					displayName: state?.user?.displayName || profile?.displayName,
					// role: currRole,
					phoneNumber: state?.user?.phoneNumber || profile?.phoneNumber || '',
					country: profile?.country || '',
					address: profile?.address || '',
					state: profile?.state || '',
					city: profile?.city || '',
					zipCode: profile?.zipCode || '',
					about: profile?.about || '',
					isPublic: profile?.isPublic || false,
                    role: state?.user?.role || "",
				},
				loginWithEmailPassword,
				register,
				logout,
				resendEmail,
                resetPassword,
				getPhoneAuthProvider,
				setUserAuth,
				getUserId,
				getUserIdToken,
				auth:AUTH,
                db:DB,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
}

export { AuthContext, AuthProvider };
